import { api } from "../client";
import { ServicedProductChangelog } from "../schema/ServicedProductChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<ServicedProductChangelog[]>;

export const getServicedProductChangelog = async (
  servicedProductId: number,
  config?: ApiRequestConfig
) => {
  return api.get<ServicedProductChangelog[]>(
    `serviced_products/${servicedProductId}/serviced_product_histories`,
    config
  );
};
